import { useRef } from 'react';
import {
  Box, Container, Grid, VStack, Wrap, Text,
  List,
  ListItem,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import Pagination from '../../components/Pagination';
import E3Quality from './components/report-sections/E3Quality';
import E3Cost from './components/report-sections/E3Cost';
import E3Quantity from './components/report-sections/E3Quantity';
import E3PeerGroup from './components/report-sections/E3PeerGroup';
import E3ReportHeader from './components/report-headers/E3ReportHeader';
import PrintablePdf from '../../components/PrintablePdf';
import DataDisclaimer from '../../components/DataDisclaimer';
import E3Trends from './components/report-sections/E3Trends';

function E3() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Value for Money, Efficiency and Effectiveness"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                REG has developed an initial benchmarking system to measure maintenance efficiency, effectiveness and value for money for Road Controlling Authorities (RCAs).
              </Text>
              <Text mb={4}>
                Definition of these measures:
              </Text>
              <List mb={4} styleType="disc" stylePosition="inside">
                <ListItem>
                  <strong>Efficiency:</strong>
                  {' '}
                  how much is being done for the amount spent?
                </ListItem>
                <ListItem>
                  <strong>Effectiveness:</strong>
                  {' '}
                  how good is the network for the amount of work done?
                </ListItem>
                <ListItem>
                  <strong>Value for money:</strong>
                  {' '}
                  how good is the network for the amount spent?
                </ListItem>
              </List>
              <Text mb={4}>
                These three dimensions offer a view of maintenance performance and enable RCAs to compare their maintenance delivery outcomes to others. Comparisons between RCAs need to account for differences in challenges and cost drivers.
              </Text>
              <Text mb={4}>
                This dashboard will help RCAs to gain insights to improve their performance by learning from their peers and identifying areas to enhance efficiency and effectiveness.
              </Text>
              <Text mb={4}>
                REG will enhance these comparisons as more comprehensive pavement condition data is gathered through the Consistent Condition Data Collection project and by applying Data Envelope Analysis across local and state highway networks.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <E3ReportHeader />
          <Grid
            templateColumns={{ base: '1fr', '2xl': '1fr 2fr' }}
            gap={2}
            alignItems="start"
            className="e3-grid"
          >
            <E3PeerGroup />
            <VStack spacing={2} align="stretch">
              <E3Trends />
              <Wrap
                spacing={2}
                flexGrow={1}
              >
                <E3Quality />
                <E3Cost />
                <E3Quantity />
              </Wrap>
            </VStack>
          </Grid>
          <DataDisclaimer />
        </Box>
      </Container>
    </MainLayout>
  );
}

export default E3;
